export interface SuggestedDocket {
  docket_number: string;
  label: string;
  description: string;
}

/**
 * Curated list of high-profile active FCC proceedings shown on /onboarding.
 * Kept intentionally short (5) so the page stays focused on the search bar.
 *
 * IMPORTANT: docket_number, label, and description must all agree with the
 * real FCC proceeding — the onboarding cards render the live ECFS title, so a
 * mismatched number surfaces a title that contradicts the description. Titles
 * below are verified against the ECFS proceedings API.
 */
export const CURATED_DOCKETS: SuggestedDocket[] = [
  {
    docket_number: '23-320',
    label: 'Safeguarding and Securing the Open Internet',
    description: 'Net neutrality / open internet rulemaking',
  },
  {
    docket_number: '17-59',
    label: 'Advanced Methods to Target and Eliminate Unlawful Robocalls',
    description: 'Robocall mitigation and enforcement',
  },
  {
    docket_number: '22-2',
    label: 'Empowering Broadband Consumers Through Transparency',
    description: 'Broadband consumer labels and transparency',
  },
  {
    docket_number: '22-271',
    label: 'Space Innovation',
    description: 'Next-generation satellite and space systems',
  },
  {
    docket_number: '21-476',
    label: 'Report on the Future of the Universal Service Fund',
    description: 'Future of the Universal Service Fund',
  },
];
